// shared-library/store/modules/funnel.js
// 创建一个变量来存储 API 实例的 getter 函数
let getApiInstance = null;

// 提供设置 API 实例 getter 的方法
export function setApiGetter(getter) {
  getApiInstance = getter;
}

// 获取当前 API 实例的辅助函数
function getApi() {
  if (!getApiInstance) {
    throw new Error('API getter not set. Please initialize the funnel module with an API instance.');
  }
  const api = getApiInstance();
  if (!api || !api.funnelApi) {
    throw new Error('Invalid API instance. Make sure the API object has funnelApi property.');
  }
  return api;
}

const state = {
  // 商机漏斗数据
  funnels: [],
  funnelLoading: false,
  funnelError: null
}

const getters = {
  // 商机漏斗数据
  funnels: state => state.funnels,
  funnelLoading: state => state.funnelLoading,
  funnelError: state => state.funnelError
}

const actions = {
  /**
   * 获取所有商机漏斗数据
   */
  async fetchAllFunnels({ commit }) {
    commit('setFunnelLoading', true);
    commit('clearFunnelError');
    
    try {
      const api = getApi();
      const response = await api.funnelApi.getAllFunnels();
      if (response.data.success) {
        commit('setFunnels', response.data.data);
        return response.data.data;
      } else {
        throw new Error(response.data.message || '获取商机漏斗数据列表失败');
      }
    } catch (error) {
      commit('setFunnelError', error.response?.data?.message || '获取商机漏斗数据列表失败');
      throw error;
    } finally {
      commit('setFunnelLoading', false);
    }
  },

  /**
   * 推进商机
   * @param {object} context - Vuex上下文
   * @param {object} payload - 包含funnelId和pushData的对象
   */
  async pushFunnel({ commit, dispatch }, { funnelId, pushData }) {
    commit('setFunnelLoading', true);
    commit('clearFunnelError');
    
    try {
      const api = getApi();
      const response = await api.funnelApi.pushFunnel(funnelId, pushData);
      if (response.data.success) {
        // 推进成功后重新获取所有商机数据
        await dispatch('fetchAllFunnels');
        return response.data;
      } else {
        throw new Error(response.data.message || '推进商机失败');
      }
    } catch (error) {
      commit('setFunnelError', error.response?.data?.message || '推进商机失败');
      throw error;
    } finally {
      commit('setFunnelLoading', false);
    }
  },

  /**
   * 修改商机
   * @param {object} context - Vuex上下文
   * @param {object} payload - 包含funnelId和updateData的对象
   */
  async updateFunnel({ commit, dispatch }, { funnelId, updateData }) {
    commit('setFunnelLoading', true);
    commit('clearFunnelError');
    
    try {
      const api = getApi();
      const response = await api.funnelApi.updateFunnel(funnelId, updateData);
      if (response.data.success) {
        // 更新成功后重新获取所有商机数据
        await dispatch('fetchAllFunnels');
        return response.data;
      } else {
        throw new Error(response.data.message || '修改商机失败');
      }
    } catch (error) {
      commit('setFunnelError', error.response?.data?.message || '修改商机失败');
      throw error;
    } finally {
      commit('setFunnelLoading', false);
    }
  }
}

const mutations = {
  // 商机漏斗数据
  setFunnels(state, funnels) {
    state.funnels = funnels;
  },
  
  setFunnelLoading(state, status) {
    state.funnelLoading = status;
  },
  
  setFunnelError(state, error) {
    state.funnelError = error;
  },
  
  clearFunnelError(state) {
    state.funnelError = null;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}